import { Size } from "@repo/ui/helpers/helpers";
import { Label } from "@repo/ui/Label/label";
import type { FC } from "react";
import {
  DiffableField,
  type FieldView,
} from "../../../components/diffableField.js";

interface SharedToolFormFieldsProps {
  name: string;
  description: string;
  /** The saved name to diff against; `undefined` for a new tool. */
  originalName: string | undefined;
  /** The saved description to diff against; `undefined` for a new tool. */
  originalDescription: string | undefined;
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
  namePlaceholder: string;
  descriptionPlaceholder: string;
  isReadOnly: boolean;
  /** Controls the fields' view. When set, their view toggles don't render. */
  view?: FieldView;
}

/**
 * The value to diff a field against. Saved trimmed, so whitespace at either
 * end isn't a change.
 */
function readOriginalValue(
  originalValue: string | undefined,
  value: string,
): string | undefined {
  return originalValue === value.trim() ? value : originalValue;
}

export const SharedToolFormFields: FC<SharedToolFormFieldsProps> = (props) => {
  const {
    name,
    description,
    originalName,
    originalDescription,
    onNameChange,
    onDescriptionChange,
    namePlaceholder,
    descriptionPlaceholder,
    isReadOnly,
    view,
  } = props;

  return (
    <>
      <div>
        <DiffableField
          label={<Label size={Size.SMALL}>Name</Label>}
          value={name}
          onChange={onNameChange}
          originalValue={readOriginalValue(originalName, name)}
          placeholder={namePlaceholder}
          maxLength={100}
          variant="input"
          isReadOnly={isReadOnly}
          view={view}
        />
      </div>

      <div className="col-span-full">
        <DiffableField
          label={<Label size={Size.SMALL}>Description</Label>}
          value={description}
          onChange={onDescriptionChange}
          originalValue={readOriginalValue(originalDescription, description)}
          description="Clearly describe what this tool does and how it should be used by the voice agent."
          placeholder={descriptionPlaceholder}
          isReadOnly={isReadOnly}
          view={view}
        />
      </div>
    </>
  );
};
